import React from 'react';
import { ConfluenceIcon } from '@atlaskit/logo/confluence-icon';
import { JiraIcon } from '@atlaskit/logo/jira-icon';
import { CONFLUENCE_GENERATOR_ID, JIRA_GENERATOR_ID } from '../constants';
import { extractUrlFromIconJsonLd, extractUrlFromLinkJsonLd } from '../url';
/**
 * @deprecated Use extractSmartLinkProvider instead
 */
export var extractProvider = function extractProvider(jsonLd) {
  var generator = jsonLd.generator;
  if (generator) {
    if (typeof generator === 'string') {
      throw Error('Link.generator requires a name and icon.');
    } else if (generator['@type'] === 'Link') {
      if (generator.name) {
        return {
          text: generator.name
        };
      }
    } else {
      if (generator.name) {
        var id = generator['@id'];
        return {
          text: generator.name,
          icon: extractProviderIcon(generator.icon, id),
          id: id,
          image: extractProviderImage(generator.image)
        };
      }
    }
  }
};
export var extractProviderIcon = function extractProviderIcon(icon, id) {
  if (id) {
    if (id === CONFLUENCE_GENERATOR_ID) {
      return /*#__PURE__*/React.createElement(ConfluenceIcon, {
        appearance: "brand",
        size: "xxsmall"
      });
    } else if (id === JIRA_GENERATOR_ID) {
      return /*#__PURE__*/React.createElement(JiraIcon, {
        appearance: "brand",
        size: "xxsmall"
      });
    }
  }
  if (icon) {
    return extractUrlFromIconJsonLd(icon);
  }
};
var extractProviderImage = function extractProviderImage(image) {
  if (image) {
    if (typeof image === 'string') {
      return image;
    } else if (image['@type'] === 'Link') {
      return extractUrlFromLinkJsonLd(image);
    } else if (image['@type'] === 'Image') {
      if (image.url) {
        return extractUrlFromLinkJsonLd(image.url);
      }
    }
  }
};
export var isConfluenceGenerator = function isConfluenceGenerator(id) {
  return id === CONFLUENCE_GENERATOR_ID;
};